

const HideButton = ({ hideTable, hideBtn }) => {
    return (
        <span className="wind-table-hide" onClick={hideTable}>{hideBtn}</span>
    )
}

export default HideButton;